import { workspaceAccessControl, workspaceOrganizationRoles } from '@amore/shared'
import { adminClient, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

/**
 * Better Auth ships its own typed client, so auth stays outside the Hono RPC
 * surface. Empty baseURL keeps /api/auth same-origin through Vite and Cloudflare.
 */
export const authClient = createAuthClient({
  baseURL: '',
  basePath: '/api/auth',
  plugins: [
    // Only for the platform `role` on the session user; admin endpoints are not mounted.
    adminClient(),
    organizationClient({
      ac: workspaceAccessControl,
      roles: workspaceOrganizationRoles,
    }),
  ],
})

export const { signIn, signUp, signOut, useSession } = authClient

export type Session = typeof authClient.$Infer.Session
